if (!window.dataLayer[0].itcsUser) {
  import('../javascripts/impressions/capture_impression.js').then((module => module.captureImpression()))
}